import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UnregisterAliasRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UnregisterAliasResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const unregisterAlias = (request: UnregisterAliasRequest, options?: CashRequestOptions) =>
  post<UnregisterAliasRequest, UnregisterAliasResponse>('/2.0/cash/unregister-alias', request, {
    ...options,
    rejectOnError: true,
  })
